import { request } from '~/agent';

export const getTemplates = params => {
    return request.get(`screening/application/templates`, params);
};

export const getTemplate = (id, params) => {
    return request.get(`screening/application/templates/${id}`, params);
};

export const getSubmittedTemplate = (id, params) => {
    return request.get(`screening/applications/templates/${id}`, params);
};

export const getGenericApplication = () => {
    return request.get(`screening/applications/templates/generic`);
};

export const getApplicationTemplate = (id, params) => {
    if (id) {
        return request.get(`screening/applications/templates/${id}`, params);
    }
    return request.get(`screening/applications/templates/default`, params);
};

export const validateStep = (currentStep, data, params) => {
    return request.post(`screening/applications/validate?stepID=${currentStep}`, data, params);
};

export const saveApplication = (data, params) => {
    return request.post(`screening/applications`, data, params);
};

export const getReceipt = (applicationID, applicantID, params) => {
    return request.get(`apply/receipt/${applicationID}/${applicantID}`, params);
};

export const getUnitForApplication = (unitID, queryString) => {
    if (queryString) {
        return request.get(`screening/applications/templates/for-unit?startedApplicationUUID=${queryString}`);
    }
    return request.get(`screening/applications/templates/for-unit?unitID=${unitID}`);
};

export const getStartedApplication = (id, params) => {
    return request.get(`screening/startedApplications/${id}`, params);
};

export const createStartedApplication = params => {
    return request.post(`screening/startedApplications`, params);
};

export const updateStartedApplication = (uuid, stepID, params) => {
    return request.post(`screening/startedApplications/${uuid}?stepID=${stepID}`, params);
};

export const fetchIncomeVerificationToken = (uuid, params) => {
    return request.get(`screening/verification/income/status/${uuid}`, params);
};

export const setIncomeVerificationToken = (uuid, params) => {
    return request.post(`screening/verification/income/token/${uuid}`, params);
};

export const fetchIdentityVerificationToken = (uuid, params) => {
    return request.get(`screening/verification/identity/status/${uuid}`, params);
};

export const getApplicationGroup = (applicationID, params) => {
    return request.get(`screening/groups/${applicationID}`, params);
};

export const createApplicationGroup = data => {
    return request.post(`screening/groups`, data);
};

export const getLandlordVerification = (uuid) => {
    return request.get(`screening/landlord-verifications/${uuid}`);
};

export const submitLandlordVerification = (uuid, data) => {
    return request.post(`screening/landlord-verifications/${uuid}`, data);
};